import type { TriggerIziviaMonprojetCasesResponseDto } from '@evimo/types';
import { buildApiUrl } from '~/app/lib/api-config';

export async function triggerIziviaMonprojetCases(
  organizationId: string,
): Promise<TriggerIziviaMonprojetCasesResponseDto> {
  const response = await fetch(
    buildApiUrl('/api/v1/izivia/monprojet/cases/trigger'),
    {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ organizationId }),
    },
  );

  if (!response.ok) {
    const payload = (await response.json().catch(() => null)) as {
      message?: string | string[];
    } | null;

    const message = Array.isArray(payload?.message)
      ? payload.message.join('; ')
      : payload?.message;

    throw new Error(message ?? '');
  }

  return (await response.json()) as TriggerIziviaMonprojetCasesResponseDto;
}
